var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 62623",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.023,
    height: 33.237,
    viewBox: "0 0 33.023 33.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "orzk910qba",
    cx: 0.298,
    cy: 0.274,
    r: 0.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff436d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#fe2743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe1020"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13040"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13039"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9215",
    d: "M2864.824 4523.118a16.512 16.512 0 1 1-16.512-16.618 16.325 16.325 0 0 1 10.259 3.606 16.607 16.607 0 0 1 6.253 13.012z",
    transform: "translate(-2831.8 -4506.5)",
    style: {
      fill: "url(#orzk910qba)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13045"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13042",
    transform: "translate(19.628 5.371)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13041"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9216",
    d: "M5.316 1.347.468 4.105a.281.281 0 0 1-.422-.141c-.071-.142-.071-.354.07-.424L4.543.14a.685.685 0 0 1 .984.142.694.694 0 0 1-.141.99z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 162",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192,
    transform: "translate(.327 5.661)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13044",
    transform: "translate(7.802 5.377)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13043"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9217",
    d: "m1.122.138 4.427 3.395a.438.438 0 0 1 .07.5c-.07.142-.281.142-.421.07L.349 1.345a.786.786 0 0 1-.281-.99.753.753 0 0 1 .983-.282c.001.065.001.065.071.065z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 163",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192,
    transform: "translate(.911 5.655)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13046"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9218",
    d: "M9.415 26.448a4.651 4.651 0 0 1 .843-2.121 6.2 6.2 0 0 1 1.757-1.556 8.42 8.42 0 0 1 4.5-1.2 9.115 9.115 0 0 1 4.5 1.2 6.2 6.2 0 0 1 1.757 1.556 3.994 3.994 0 0 1 .843 2.121.069.069 0 0 1-.07.071h-.071a6.081 6.081 0 0 0-3.232-2.333 8.74 8.74 0 0 0-1.827-.5 8.6 8.6 0 0 0-1.9-.141 17.092 17.092 0 0 0-1.9.141 7.706 7.706 0 0 0-1.827.5 6.942 6.942 0 0 0-3.232 2.333c-.069 0-.069 0-.14-.071z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.833c089ab63baee6b0a26f9b802d26cf.svg";
export { ForwardRef as ReactComponent };